import { COMPLAINTS_API_ERROR } from "../actions";
const intialState = {
    error: undefined,
};
export const errors = (state = intialState, { type, payload }) => {
    switch (type) {
        case COMPLAINTS_API_ERROR:
            return Object.assign(Object.assign({}, state), { error: payload });
        default:
            return state;
    }
};
